<template>
  <div :class="`formulate-input-element  formulate-input-element--${context.type}`"
    
    :data-type="context.type"
  >
    <!-- placeholder="DD/MM/YYYY" -->
    <input class=""  type="text" 
            v-mask="mask"
            v-model="context.model"
            v-bind="context.attributes"
            @blur="context.blurHandler"
    />
    </div>
</template>

<script>


export default {
  props: {
    context: {
      type: Object,
      required: true
    },
    mask: {
      type: String,
      required: true
    },
  },
  data () {
    return {
        
    }
  },
  watch: {
    model () {
    }
  },
  computed: {
    model () {
      return this.context.model
    }
  },
  methods: {
  },
}
</script>

<style>

</style>